<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaPostInput',
})
</script>
<template>
	<el-input v-model="postName" :clearable :disabled readonly :placeholder @clear="model = ''">
		<template #append>
			<el-button icon="Search" @click="visible = true"></el-button>
		</template>
	</el-input>
	<ma-data-table
		v-if="!disabled && visible"
		:key="visible + ''"
		v-model:visible="visible"
		:title="t('maPost.selectPost')"
		url="/sys/post/page"
		:multiple="true"
		:columns="[
			{ field: 'postCode', label: t('maPost.postCode') },
			{ field: 'postName', label: t('maPost.postName') }
		]"
		:query-params="[
			{ field: 'postCode', label: t('maPost.postCode') },
			{ field: 'postName', label: t('maPost.postName') }
		]"
		@select="onSelect"
	></ma-data-table>
</template>

<script setup lang="ts" name="MaPostInput">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { usePostNameListApi } from '@/api/sys/post'
const { t } = useI18n()

const props = defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	},
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	}
})

const model = defineModel<any | any[]>()
const visible = ref(false)
const postName = ref()

watch(
	() => model.value,
	async val => {
		if (val) {
			const idList = props.multiple ? val : [val]
			if (idList.length > 0) {
				const { data } = await usePostNameListApi(idList)
				postName.value = data.join(',')
			}
		} else {
			postName.value = ''
		}
	},
	{
		immediate: true
	}
)

const emit = defineEmits(['select'])
const onSelect = (rows: any[]) => {
	if (props.multiple) {
		model.value = rows.map((item: any) => item.id)
	} else {
		model.value = rows[0].id
	}

	emit('select', rows)
}
</script>
